import "antd/dist/antd.css";
import { initForFetchEventSource } from "apis/fetchEventSource";
import { UrlInternal } from "common/constants/endpoints";
import GlobalStyles from "common/style/GlobalStyle";
import Normalize from "common/style/Normalize";
import defaultTheme from "common/style/themes/default";
import { FooterPage, PopupHandleAdmin } from "components";
import MobileFooterMain from "components/MobileFooterMain";
import useWindowSize, { Size } from "hooks/useWindowSize";
import React, { lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Switch, withRouter } from "react-router-dom";
import { PrivateRoute, PublicRoute } from "router";
import rootAction from "store/actions";
import { ThemeProvider } from "styled-components";
import ScrollToTop from "utils/ScrollToTop";
import { getLocalStorage } from "utils/localStorage";
import { BLOCK_IP, GETME } from "utils/localStorage/type";

const Home = lazy(() => import("pages/Home"));
const Login = lazy(() => import("pages/Login"));
const LOGIN_REDIRECT = lazy(() => import("pages/Login/loginRedirect"));
const AgreeTermsRegister = lazy(() => import("pages/Register/AgreeTerms"));
const PersonalInfoRegister = lazy(() => import("pages/Register/PersonalInfo"));
const CompanyRegister = lazy(() => import("pages/Register/Company"));
const GroupSale = lazy(() => import("pages/GroupSale"));
const PurchaseSummary = lazy(() => import("pages/OwnerShip/PurchaseSummary"));
const PageNotFound = lazy(() => import("pages/PageNotFound"));
const RegisterAppointment = lazy(
  () => import("pages/Appointment/RegisterAppointment")
);
const MyPage = lazy(() => import("pages/MyPage"));
const ArtMarket = lazy(() => import("pages/ArtMarket"));
const FindIdPassword = lazy(() => import("pages/FindIdPassword"));
const LinkAgreeTerm = lazy(() => import("pages/LinkPage/LinkAgreeTerm"));
const NaverSnS = lazy(() => import("pages/Login/naverSns"));
const KakaoSnS = lazy(() => import("pages/Login/kakaoSns"));
const GoogleSnS = lazy(() => import("pages/Login/googleSns"));
const FacebookSns = lazy(() => import("pages/Login/facebookSns"));
const SnsKakaoNaver = lazy(() => import("pages/Login/SnsKakaoNaver"));
const CustomerService = lazy(() => import("pages/CustomService"));
const Insight = lazy(() => import("pages/Insight"));
const NiceVerify = lazy(() => import("pages/Register/niceVerify"));
const FormNiceApi = lazy(() => import("pages/FormNiceApi"));
const CollectUserInformation = lazy(
  () => import("pages/CollectUserInformation")
);
const Maintenance = lazy(() => import("pages/Maintenance"));
const VoteHoldingProduct = lazy(() => import("pages/VoteHoldingProduct"));

const App: React.FC = (props: any) => {
  const dispatch = useDispatch();
  let blockIp = getLocalStorage(BLOCK_IP, 0);
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 767;

  useEffect(() => {
    window?.qg("event", "page_viewed", {
      url: window.location.href,
      define: "spa",
    });
    props.history.listen((location: any, action: any) => {
      window?.qg("event", "page_viewed", {
        url: window.location.href,
        define: "spa",
      });
    });
  }, []);

  useEffect(() => {
    if (!blockIp) {
      dispatch(rootAction.getCategoriesTerm.getCategoriesTerm());
      initForFetchEventSource();

      if (getLocalStorage(GETME, 0) !== null) {
        dispatch(rootAction.getInfoShinhan.getInfoShinhan());
      }
    }
  }, [blockIp]);

  return (
    <ThemeProvider theme={defaultTheme}>
      <>
        {!blockIp && <PopupHandleAdmin />}
        <Normalize />
        <GlobalStyles />
        <ScrollToTop />
        <Switch>
          <PublicRoute exact path={UrlInternal.HOME} component={Home} />

          {/**login , register */}
          <PublicRoute exact path={UrlInternal.LOGIN} component={Login} />
          <PublicRoute
            exact
            path={UrlInternal.LOGIN_REDIRECT}
            component={LOGIN_REDIRECT}
          />

          <PublicRoute
            exact
            path={UrlInternal.LOGIN_NAVER_SNS}
            component={NaverSnS}
          />
          <PublicRoute
            exact
            path={UrlInternal.LOGIN_KAKAO_SNS}
            component={KakaoSnS}
          />
          <PublicRoute
            exact
            path={UrlInternal.LOGIN_GOOGLE_SNS}
            component={GoogleSnS}
          />
          <PublicRoute
            exact
            path={UrlInternal.LOGIN_FACEBOOK_SNS}
            component={FacebookSns}
          />

          <PublicRoute
            exact
            path={UrlInternal.SNS_KAKAO_NAVER}
            component={SnsKakaoNaver}
          />

          <PublicRoute
            exact
            path={UrlInternal.REGISTER_AGREE_TERMS}
            component={AgreeTermsRegister}
          />
          <PublicRoute
            exact
            path={UrlInternal.REGISTER_PERSONAL_INFO}
            component={PersonalInfoRegister}
          />
          <PublicRoute
            exact
            path={UrlInternal.REGISTER_COMPANY}
            component={CompanyRegister}
          />

          <PublicRoute
            exact
            path={UrlInternal.FIND_ID_PASSWORD}
            component={FindIdPassword}
          />

          {/**CUSTOMER SERVICE */}
          <PublicRoute
            exact
            path={UrlInternal.CUSTOMER_SERVICE}
            component={CustomerService}
          />

          {/** INSIGHT */}
          <PublicRoute exact path={UrlInternal.INSIGHT} component={Insight} />

          {/** Group Sale */}
          <PublicRoute
            exact
            path={UrlInternal.GROUP_SALE}
            component={GroupSale}
          />
          <PublicRoute
            exact
            path={UrlInternal.PURCHASE_SUMMARY}
            component={PurchaseSummary}
          />

          <PublicRoute
            exact
            path={UrlInternal.REGISTER_APPOINTMENT}
            component={RegisterAppointment}
          />
          {/** My page */}
          <PrivateRoute exact path={UrlInternal.MYPAGE} component={MyPage} />

          {/** Art Market */}
          <PublicRoute
            exact
            path={UrlInternal.ART_MARKET}
            component={ArtMarket}
          />
          <PublicRoute
            exact
            path={UrlInternal.ART_AGREE_TERM}
            component={LinkAgreeTerm}
          />

          {/**nice api */}
          <PublicRoute
            exact
            path={UrlInternal.NICE_VERIFY_RESULT}
            component={NiceVerify}
          />
          <PublicRoute
            exact
            path={UrlInternal.NICE_FORM}
            component={FormNiceApi}
          />
          <PublicRoute
            exact
            path={UrlInternal.COLLECT_USER_INFORMATION}
            component={CollectUserInformation}
          />
          <PublicRoute
            exact
            path={UrlInternal.VOTE_HOLDING_PRODUCT}
            component={VoteHoldingProduct}
          />

          <PublicRoute
            exact
            path={UrlInternal.MAINTENANCE}
            component={Maintenance}
          />

          <PublicRoute exact path={"*"} component={PageNotFound} />
        </Switch>
        {!blockIp && !isMobile && <FooterPage />}
        {!blockIp && isMobile && <MobileFooterMain />}
      </>
      {/* ) : (
        <PublicRoute exact path={"*"} component={Maintenance} />
      )} */}
    </ThemeProvider>
  );
};

export default withRouter(App);
